export class Property
{
	propertyId: number;
	createDate: Date;
	lastUpdate: Date;
	sendDate: Date;
	receiveDate: Date;
	propertyType: string;
	sendByText: boolean;
	sendByEmail: boolean;
	propertyStatus: string;
	property: string;
	toFirstName: string;
	toLastName: string;
	toEmailAddress: string;
	toPhoneNumber: string;
	toPhoneCountryCode: string;
	toSubject: string;
	confirmationId: string;
	opsNotes: string;
	debug: string;
}
